import msCombobox from "./MsCombobox";

export default {
  name: "msComboboxEnum",
  extends: msCombobox,
  props: {
    enum: {
      default: null,
      type: String
    },
    /**
     * @override
     */
    valueField: {
      type: String,
      default: "enumValue"
    },
    /**
     * @override
     */
    displayField: {
      type: String,
      default: "enumText"
    },
    values: {
      type: Array,
      default: null
    },
    addAllItem: {
      type: Boolean,
      default: false
    },
    allValue: {
      type: Object,
      default: null
    }
  },
  created() {
    this.loadEnumSource();
  },
  mounted() {},
  methods: {
    loadEnumSource() {
      const me = this;

      let source = me.$ms.commonFn.getEnumSource(me.enum, me.values);
      if (me.addAllItem) {
        source.unshift({
            enumValue: me.allValue,
            enumText: me.$t('i18nComponent.Combobox.SelectAllItemText')
        });
      }
      me._allData = source;
    }
  }
};
